import { useEffect, useState } from 'react';
import { Button, Alert } from 'react-bootstrap';
import fileDownloadNamed from "../../services/fileDownloadNamed";
import api from "../../services/api";

import styles from './Headers.module.scss'
import { useTranslation } from 'react-i18next';

export default function HeadersPrint({ reportUrl, isReadOnly, isActive }) {
  const { t } = useTranslation();
  const [pdfUrl, setPdfUrl] = useState(null);
  const [loading, setLoading] = useState(true);
  const [refreshKey, setRefreshKey] = useState(0);
  
  let loadPdfToMemory = async (url) => {
    try {
      const response = await api.get(url, {
        responseType: 'blob',
      });

      const file = new Blob([response.data], { type: response.data.type });
      const fileURL = URL.createObjectURL(file);
      return fileURL;
    } catch (error) {
      console.log(error);
      return null;
    }
  };

  useEffect(() => {
    // Only fetch PDF when tab is active
    if (!isActive) {
      return;
    }

    const fetchPdf = async () => {
      setLoading(true);
      
      // Clean up previous PDF URL to free memory
      if (pdfUrl) {
        URL.revokeObjectURL(pdfUrl);
        setPdfUrl(null);
      }
      
      // Use draft-pdf endpoint for non-readonly reports, regular pdf for completed reports
      const pdfEndpoint = isReadOnly ? `${reportUrl}/pdf` : `${reportUrl}/draft-pdf`;
      // Add timestamp to force cache bypass for draft PDFs
      const urlWithTimestamp = isReadOnly ? pdfEndpoint : `${pdfEndpoint}?t=${Date.now()}`;
      const url = await loadPdfToMemory(urlWithTimestamp);
      setPdfUrl(url);
      setLoading(false);
    };

    fetchPdf();

    // Cleanup function to revoke URL when component unmounts
    return () => {
      if (pdfUrl) {
        URL.revokeObjectURL(pdfUrl);
      }
    };
  }, [reportUrl, isReadOnly, isActive, refreshKey]);

  const handleRefresh = () => {
    setRefreshKey(prev => prev + 1);
  };

  return (
    <>
      <div className={`${styles.mainHeaderPaddingPrint} ${styles.mainHeaderLinePrint}`}>
        {!isReadOnly && (
          <>
            <Alert variant="info" className="mb-3 d-flex justify-content-between align-items-center">
              <span>{t('consultation.protocol.print.draftNotice') || 'This is a draft preview. The final PDF will be generated after the report is completed.'}</span>
              <Button 
                variant="outline-primary" 
                size="sm"
                onClick={handleRefresh}
                disabled={loading}
              >
                {t('consultation.protocol.print.refresh') || 'Refresh'}
              </Button>
            </Alert>
          </>
        )}
        {loading && <p>{t('consultation.protocol.print.loading') || 'Loading PDF preview...'}</p>}
        {!loading && (
          <object data={pdfUrl} type="application/pdf" width="100%" height="100%" >
            <p>{t('consultation.protocol.print.unableToDisplay')}</p>
            <p>
              <Button 
                variant="link" 
                onClick={() => fileDownloadNamed(isReadOnly ? `${reportUrl}/pdf` : `${reportUrl}/draft-pdf`)}
              >
                {t('consultation.protocol.print.downloadPdf')}
              </Button>
            </p>
          </object>
        )}
      </div>      
    </>
  );
}

